import { pick } from 'es-toolkit';
export function transformDeviceGrantSessionResponse(response) {
    if (response.verificationUriComplete.startsWith('?')) {
        response.verificationUriComplete = `https://tunein.com/authorize${response.verificationUriComplete}`;
    }
    if (response && !response.verificationUri) {
        response.verificationUri = 'https://tunein.com/auto';
    }
    const pinCodeUrl = new URL(response.verificationUri);
    return {
        deviceCode: response.deviceCode,
        interval: Number.parseInt(response.interval),
        expiresIn: Number.parseInt(response.expiresIn),
        qrCodeUrl: response.verificationUriComplete,
        pinCode: response.userCode,
        pinCodeUrlFull: pinCodeUrl.href,
        pinCodeUrlLabel: `${pinCodeUrl.hostname}${pinCodeUrl.pathname}`,
    };
}
function hasAuthTokenKeyId(item) {
    return item?.key === 'oauth';
}
export function transformAuthResponse(response) {
    const rawAuthTokenData = response.find(hasAuthTokenKeyId) || {};
    return pick(rawAuthTokenData, ['accessToken', 'refreshToken', 'expiresIn']);
}
